__turbopack_context__.v({
  "content": "profile-header-module-scss-module__mE6oBW__content",
  "cover": "profile-header-module-scss-module__mE6oBW__cover",
  "dark-text": "profile-header-module-scss-module__mE6oBW__dark-text",
  "description": "profile-header-module-scss-module__mE6oBW__description",
  "name": "profile-header-module-scss-module__mE6oBW__name",
  "profile-header": "profile-header-module-scss-module__mE6oBW__profile-header",
  "ratings-link": "profile-header-module-scss-module__mE6oBW__ratings-link",
  "star": "profile-header-module-scss-module__mE6oBW__star",
  "stat": "profile-header-module-scss-module__mE6oBW__stat",
  "stat-label": "profile-header-module-scss-module__mE6oBW__stat-label",
  "stat-metric": "profile-header-module-scss-module__mE6oBW__stat-metric",
  "stat-value": "profile-header-module-scss-module__mE6oBW__stat-value",
  "stats": "profile-header-module-scss-module__mE6oBW__stats",
  "text-block": "profile-header-module-scss-module__mE6oBW__text-block",
});
